var render = function render() {
  var _vm$sections$mainSect, _vm$sections$mainSect2, _vm$sections$offerSec, _vm$content$offer, _vm$content, _vm$sections$partnerS, _vm$sections$partnerS2, _vm$content2, _vm$sections$sellOnli, _vm$sections$sellOnli2, _vm$content3, _vm$sections$managerS;
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    class: _vm.$style.IndexPage
  }, [_c('LandingHeroSection', {
    attrs: {
      "title": (_vm$sections$mainSect = _vm.sections.mainSection) === null || _vm$sections$mainSect === void 0 ? void 0 : _vm$sections$mainSect.title,
      "text": (_vm$sections$mainSect2 = _vm.sections.mainSection) === null || _vm$sections$mainSect2 === void 0 ? void 0 : _vm$sections$mainSect2.text
    }
  }), _vm._v(" "), _c('LandingOfferSection', {
    attrs: {
      "title": (_vm$sections$offerSec = _vm.sections.offerSection) === null || _vm$sections$offerSec === void 0 ? void 0 : _vm$sections$offerSec.title,
      "items": (_vm$content$offer = (_vm$content = _vm.content) === null || _vm$content === void 0 ? void 0 : _vm$content.offer) !== null && _vm$content$offer !== void 0 ? _vm$content$offer : []
    }
  }), _vm._v(" "), _c('LandingPartnersSection', {
    attrs: {
      "title": (_vm$sections$partnerS = _vm.sections.partnerSection) === null || _vm$sections$partnerS === void 0 ? void 0 : _vm$sections$partnerS.title,
      "text": (_vm$sections$partnerS2 = _vm.sections.partnerSection) === null || _vm$sections$partnerS2 === void 0 ? void 0 : _vm$sections$partnerS2.text,
      "items": (_vm$content2 = _vm.content) === null || _vm$content2 === void 0 ? void 0 : _vm$content2.partnerLogo
    }
  }), _vm._v(" "), _c('LandingSignUpSection'), _vm._v(" "), _c('LandingSellOnlineSection', {
    attrs: {
      "title": (_vm$sections$sellOnli = _vm.sections.sellOnlineSection) === null || _vm$sections$sellOnli === void 0 ? void 0 : _vm$sections$sellOnli.title,
      "text": (_vm$sections$sellOnli2 = _vm.sections.sellOnlineSection) === null || _vm$sections$sellOnli2 === void 0 ? void 0 : _vm$sections$sellOnli2.text,
      "items": (_vm$content3 = _vm.content) === null || _vm$content3 === void 0 ? void 0 : _vm$content3.sellOnline
    }
  }), _vm._v(" "), _c('div', {
    class: _vm.$style.consultation
  }, [_c('div', {
    class: _vm.$style.container
  }, [_c('ConsultationSection', {
    attrs: {
      "title": (_vm$sections$managerS = _vm.sections.managerSectionTitle) === null || _vm$sections$managerS === void 0 ? void 0 : _vm$sections$managerS.title,
      "template": _vm.sections.managerSection,
      "manager": _vm.manager
    }
  })], 1)])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };